import React from 'react';
import cc from 'classcat';
import UserBox from 'components/UserBox';
import type { types as AuthModuleTypes } from 'modules/Auth';
import Auth from 'modules/Auth';
import loginMessages from './loginMessages.json';
import registerMessages from './registerMessages.json';
import AccessDeniedHeader from './AccessDeniedHeader';
import AccessDeniedContent from './AccessDeniedContent';
import AccessDeniedButton from './AccessDeniedButton';
import './accessDenied.css';

interface AccessDeniedProps {
  route: 'login' | 'register';
  prompt: AuthModuleTypes.AccessDeniedPrompt;
  className?: string;
  email?: string;
  emailMasked?: boolean;
  id?: string;
  overScroll?: boolean;
}

const ACCESS_DENIED_PROMPT = Auth.constants.ACCESS_DENIED_PROMPT;

const AccessDenied = ({
  id,
  className,
  route,
  prompt = ACCESS_DENIED_PROMPT.LOGIN,
  email = '*********@****.****',
  emailMasked = true,
  overScroll = false
}: AccessDeniedProps) => {
  const data =
    route === 'login'
      ? loginMessages[prompt] || loginMessages.FAILED
      : registerMessages[prompt] || registerMessages.FAILED;

  return (
    <UserBox id={id} className={cc(['accessDenied', className])} overScroll={overScroll}>
      <AccessDeniedHeader title={data.title} />
      <div className="accessDenied__viewcontainer">
        <div className="accessDenied__content">
          <AccessDeniedContent email={email} help={data.help}>
            {data.content}
          </AccessDeniedContent>
        </div>
        <div className="accessDenied__buttonGroup">
          {data.buttons?.map((button) => (
            <AccessDeniedButton
              key={button.text}
              color={button.color}
              href={button.href}
              email={email}
              emailMasked={emailMasked}
              openLiveChat={button.openLiveChat}
              text={button.text}
            />
          ))}
        </div>
      </div>
    </UserBox>
  );
};

export default AccessDenied;
